import React from 'react';
import * as LI from 'lucide-react';
import { ArrowUpRight, Check } from 'lucide-react';
import { services } from '../mock';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto">
          <span className="chip">Our Services</span>
          <h2 className="mt-5 text-4xl md:text-5xl font-bold tracking-tight text-[#0a2540] leading-[1.05]">
            Everything your business <span className="font-serif-display italic text-teal-600">needs</span>
          </h2>
          <p className="mt-5 text-slate-600 text-lg">
            Six powerful finance and payment products designed to help UK businesses grow, adapt and thrive — all under one roof.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = LI[s.icon];
            return (
              <div key={s.id} id={s.id} className="tilt-card group relative bg-white border border-slate-200 rounded-2xl p-7 overflow-hidden scroll-mt-24">
                <div className="absolute top-5 right-5 text-slate-200 text-xs font-mono">0{i+1}</div>
                <div className="h-12 w-12 rounded-xl bg-teal-50 flex items-center justify-center text-teal-600 group-hover:bg-teal-600 group-hover:text-white transition-colors">
                  {Icon && <Icon size={22}/>}
                </div>
                <h3 className="mt-5 text-xl font-semibold text-[#0a2540]">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                <ul className="mt-5 space-y-2">
                  {s.highlights.map((h) => (
                    <li key={h} className="flex items-center gap-2 text-sm text-slate-700">
                      <Check size={14} className="text-teal-500"/> {h}
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => scrollTo('quote')}
                  className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[#0a2540] group-hover:text-teal-600 transition-colors"
                >
                  Enquire now <ArrowUpRight size={14}/>
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
